// extracted by mini-css-extract-plugin
export var container = "_1m-0";
export var disabled = "_1m-4";
export var fullWidth = "_1m-3";
export var lined = "_1m-1";
export var selected = "_1m-5";
export var tab = "_1m-2";